// extracted by mini-css-extract-plugin
module.exports = {"inputField":"InputField_inputField__3zYte","label":"InputField_label__NYi4U","input":"InputField_input__2yp0N"};